export const SUPPORT_PHONE = '1-866-866-3613'
export const SUPPORT_EMAIL = 'support@advselect.com'
export const CREDITS_EXPIRATION_DATE = 'July 29, 2026'
